import React from "react";
import LabelValue from "../../shared/custom/labelValue/LabelValue";
import { useLanguageForShared } from "../../shared/utils/languages/useLanguageForShared";
import { concentratorType } from "../concentratorData";


export function TemplateConcentratorPulsedFlowRead({ data }: any) {
  const { t } = useLanguageForShared();
  const translateOrFallback = (key: string, fallback: string) => {
    const translated = t(key);
    return translated === key ? fallback : translated;
  };

  const ct = data?.concentratorType;
  const isPortableOrFixedPortable =
    ct === concentratorType.portable || ct === concentratorType.fixed_portable;
  const isTransportable = ct === concentratorType.transportable;

  const transportableFlowType =
    data?.["transportable.flowType"] ?? data?.transportable?.flowType ?? "";

  return (
    <>
      {isPortableOrFixedPortable && data?.pulsedFlowSettings && (
        <div className="col-sm-12 col-md-12">
          <LabelValue
            label={t("prescription.template.pulsedFlowSettings.label")}
            value={data?.pulsedFlowSettings || "-"}
            className={"me-5"}
          />
        </div>
      )}
      {isTransportable && (
        <div className="col-sm-12 col-md-12">
          {transportableFlowType && (
            <LabelValue
              label={translateOrFallback("prescription.template.flowType.label", "Tipo flusso")}
              value={translateOrFallback(
                `prescription.template.flowType.${transportableFlowType}`,
                transportableFlowType === "pulsed" ? "Pulsato" : "Continuo"
              )}
              className={"me-5"}
            />
          )}
          {transportableFlowType === "pulsed" && data?.pulsedFlowSettings && (
            <LabelValue
              label={t("prescription.template.pulsedFlowSettings.label")}
              value={data?.pulsedFlowSettings || "-"}
              className={"me-5"}
            />
          )}
        </div>
      )}
    </>
  );
}
